import React from 'react';

export const getDynamicHeight = (
  reference: React.RefObject<HTMLDivElement>,
  setRemainingHeight: (height: number) => void
) => {
  if (reference.current) {
    setTimeout(() => {
      const remainingHeight = reference?.current?.getBoundingClientRect();
      setRemainingHeight(Number(remainingHeight?.top) + 20);
    });
  }
};

/**
 * this utils only for pcc-component temprary fixes
 * capitalize a string.
 * @param text
 * @param shouldTransformToLowerCase
 * @returns
 */
export const capitalizeWord = (
  text: string,
  shouldTransformToLowerCase = true
) => {
  return text
    .split(' ')
    .map((word) => {
      const str = shouldTransformToLowerCase
        ? word.slice(1).toLowerCase()
        : word.slice(1);
      return word.charAt(0).toUpperCase() + str;
    })
    .join(' ');
};

export const getProductFamily = (text: string) => {
  return text
    .split('-')
    .map((word) => {
      const str = capitalizeWord(word.toLowerCase());
      return str;
    })
    .join('-');
};
